import React from 'react'
import styles from '../components/componentsStyles/Projects.module.css'
import ProjectImages from '../components/ProjectsComponents/ProjectImages'
import ProjectImages2 from '../components/ProjectsComponents/ProjectImages2'
import ProjectsHero from '../components/ProjectsComponents/ProjectsHero'
import ProjectsImagesMobile from '../components/ProjectsComponents/ProjectsImagesMobile'
import ProjectsImagesMobile2 from '../components/ProjectsComponents/ProjectsImagesMobile2'
import ProjectsOthers from '../components/ProjectsComponents/ProjectsOthers'

import {useGetWidh} from '../hooks/useGetWidth';
const Projects = () => {

  const isMobile = navigator.maxTouchPoints;
  const {actualDimensions} = useGetWidh();


  return (

   <>

   <div className={styles.projectsPage}>
      <ProjectsHero/>
    {
      isMobile || actualDimensions.width < 600 ?
      <>
      <ProjectsImagesMobile/>
      <ProjectsImagesMobile2/>
      </>
      
      :
      <>
      <ProjectImages/>
      <ProjectImages2/>
      </>
    }
      <ProjectsOthers/>
    </div>
   
   </>
  )
}

export default Projects